import regeneratorRuntime from "regenerator-runtime";
import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';

export default class SubmitAnAbstractFormjs {
    constructor() {
        this.running = false;
        this.utilsjs = new Utilitiesjs;
        this.ajaxjs = new Ajaxjs;
    }


    init(provinces, provinceLabel) {

        const that = this;

        that.provinces = provinces;
        that.provinceLabel = provinceLabel;

        //country province
        document.getElementById("country").onchange = function () {

            var country = this.value;

            const provinceEle = document.getElementById("province");

            provinceEle.value = "";

            country = country === "États-Unis" ? "United States" : country;

            if (country !== "Canada" && country !== "United States") {
                provinceEle.hidden = true;
                provinceEle.required = false;
                return;

            } else {
                provinceEle.hidden = false;
                provinceEle.required = true;
            }

            const filterProvince = [...that.provinces].filter(f => f.Country === country);

            const newProvinceDownlistData = filterProvince.map(province =>
                `<option value="${province.Name}">${province.Name}</option>`);

            provinceEle.innerHTML = `<option value="">${that.provinceLabel}</option>` + newProvinceDownlistData.join("");

        }
    }

    async postSubmitAnAbstractForm(e, tokenId, successMessageId, failedMessageId, loadingId, inputSectionId, iconId, successIconUrl) {
        e.preventDefault();
        var that = this;
        let button = that.utilsjs.disableButton(e);
        that.utilsjs.hideById(failedMessageId);
        that.utilsjs.hideById("failedAbstractMessage");
        that.utilsjs.showById(loadingId);
        document.getElementById(tokenId).value = await grecaptcha.execute(SiteSettings.GoogleRecaptchaKey, { action: 'submitAnAbstractFormPage' });

        if (await that.ajaxjs.serializeAndPostForm(e.target.id, 'SubmitAnAbstractFormPost', 'FileUploadForm') === '201') {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showInlineById(successMessageId);
            that.utilsjs.hideById(failedMessageId);
            that.utilsjs.hideById("failedAbstractMessage");
            that.utilsjs.hideById(inputSectionId);
            document.getElementById(iconId).src = successIconUrl;
        } else {
            that.utilsjs.hideById(loadingId);
            that.utilsjs.showById(failedMessageId);
            that.utilsjs.showById("failedAbstractMessage");
            that.utilsjs.hideById(successMessageId);

        }
        button.disabled = false;
    }


}


// WEBPACK FOOTER //
// ./Scripts/es6/controllers/submitAnAbstractForm.js